import React, { useEffect, useState } from 'react';
import { Button, Container, Stack, Typography } from '@mui/joy';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import { getAccount, AccountResponse } from '../services/account-service';

const Account = () => {
    const { signOut, userId } = useAuth();
    const navigate = useNavigate();
    const [account, setAccount] = useState<AccountResponse | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!userId) {
            navigate('/login');
            return;
        }
        getAccount()
            .then(setAccount)
            .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load account'));
    }, [userId, navigate]);

    const handleSignOut = async () => {
        await signOut();
        navigate('/');
    };

    if (!userId) return null;

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography level="h2" mb={2}>
                My Account
            </Typography>
            <Stack spacing={2}>
                {error && (
                    <Typography color="danger" level="body-sm">
                        {error}
                    </Typography>
                )}
                {account && (
                    <>
                        <Typography level="body-md">
                            <strong>Name:</strong> {account.name || '(not set)'}
                        </Typography>
                        <Typography level="body-md">
                            <strong>Player ID:</strong> {account.id}
                        </Typography>
                    </>
                )}
                <Button variant="outlined" color="danger" onClick={handleSignOut}>
                    Log Out
                </Button>
            </Stack>
        </Container>
    );
};

export default Account;
